import React, { useState , useRef } from "react";
import "./Roof_waterproofing_bituminous_sheets.css";
import { Link } from "react-router-dom";
import ContactSection2 from '../Category/ContactSection2';
import Adsense from "../Adsense";       // 🔥 ייבוא באנר דף הבית (או באנר כללי)
import InArticleAd from "../InArticleAd"; // 🔥 ייבוא המודעה החדשה לגוף המאמר

export default function Identifying_moisture_sources() {


  return (

    <div className="Roof_waterproofing_bituminous_sheets-page">
      <div className="Roof_waterproofing_bituminous_sheets-hero">
        <div className="Roof_waterproofing_bituminous_sheets-overlay">
          <h1>              זיהוי מקורות רטיבות</h1>
        </div>
<div>
</div>
</div>
    <div className="page6">
 <div className="breadcrumb6">
  <Link to="/">בית</Link> /{" "}
  <Link to="/OurServices"> השירותים שלנו </Link>/{" "}
   <Link to="/Identifying_moisture_sources"> זיהוי מקורות רטיבות  </Link>{" "}
</div>
    </div>
    
        <div className="video-line" />


 


      {/* CONTENT */}
<div className="page6">
  <div className="container">
            <div className="red-banner">
זיהוי מקורות רטיבות   </div>
    <div className="content-row2">



      <div className="text-box">
 


       <p>  
זיהו מקורות הרטיבות יתבצע ברוב המקרים לפי חוות דעתו של קבלן האיטום / יועץ האיטום ובמקרים מעטים בהם קיים קושי גדול במציאת מקור הרטיבות.



          </p>




  <h2 className="info-title">תתבצע סקירה ע"י מצלמה תרמית לאיתור מקום הרטיבות.







</h2>





      </div>

    </div>




    <ContactSection2/>
<div className="links2">


  <Link to="/Solving_and_repairing_malfunctions_in_existing_sealing_systems" className="link-right" >        פתרון ותיקון תקלות במערכות איטום קיימות</Link>
  <Link to="/Diamond_Drilling" className="link-left" >     קידוחי יהלום      </Link>


</div>

      </div>
    </div>
  

      </div>
  );
}


